import { useContext, useCallback } from "react";
import { noOp } from "../../utils/noOp.js";
import { LOGGER_PREFIX_UX_LIB } from "../useLogger/constants.js";
import { useLogger } from "../useLogger/useLogger.js";
import { InsightsContext } from "./InsightsContext.js";
import "../useLogger/LoggerContext.js";
import "react/jsx-runtime";
import "../useLogger/types.js";
import "../../_commonjsHelpers-0c53d963.js";
import "../../axios-5f69b112.js";
function useInsights(options = {}) {
  const { onEventTracked = noOp } = options, { insights } = useContext(InsightsContext), { logDebug } = useLogger(`${LOGGER_PREFIX_UX_LIB}:useInsights`);
  return {
    trackAnalyticsEvent: useCallback(
      (event) => {
        if (onEventTracked(event), !insights) {
          logDebug("trackAnalyticsEvent", "no Insights object available", event);
          return;
        }
        insights.trackAnalyticsEvent(event);
      },
      [insights, logDebug, onEventTracked]
    )
  };
}
export {
  useInsights
};
//# sourceMappingURL=useInsights.js.map
